import { useRef } from 'react';
import Text from '../../atoms/Text';

export type SubTableColumns = Array<{ header: string; accessor: string }>;

interface ISubTableProps {
  columns: SubTableColumns;
  data: any[];
  parentRow: any;
  renderSubCell(
    accessor: string,
    parentRow: any,
    row: any,
    value: any
  ): JSX.Element;
  onRowClick?(row: any): void;
}

const SubTable = ({
  columns,
  data,
  parentRow,
  renderSubCell,
  onRowClick,
}: ISubTableProps) => {
  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <div className='sub_table'>
      <div className='sub_table__thead' ref={headerRef}>
        {columns.map(({ header }) => (
          <div key={header} className='sub_table__thead__th'>
            <Text size={12}>{header}</Text>
          </div>
        ))}
      </div>
      <div
        className='sub_table__body'
        style={{ width: headerRef.current?.getBoundingClientRect().width }}
      >
        {data.map((row, index) => (
          <div
            key={index}
            className='sub_table__body__tr'
            style={{ ...(onRowClick ? { cursor: 'pointer' } : {}) }}
            onClick={() => onRowClick && onRowClick(row)}
          >
            {columns.map(({ accessor }) => {
              const cellValue = row[accessor];
              return (
                <div
                  key={`${accessor}-${index}`}
                  className='sub_table__body__tr__cell'
                >
                  {renderSubCell(accessor, parentRow, row, cellValue)}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubTable;
